import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import CommonCJAMiddleware from 'yoda-site-components/lib/middlewares/CommonCJAMiddleware';
import AccountComponentsMiddleware from 'yoda-account-components/lib/middlewares/AccountComponentsMiddleware';
import AccountAnalyticsMiddleware from './AccountMiddleWare';

const rootMiddleware = [
    AccountComponentsMiddleware,
    CommonMiddleware,
    CommonCJAMiddleware,
    AccountAnalyticsMiddleware,
];

export default rootMiddleware;
